import BaseApiManager from '../baseApiManager';
import { store } from '../../../redux/store';
import { showError } from '../../../redux/reducers/alerts/actions';

export default class GroupApi extends BaseApiManager {
  static async getInstance() {
    if (!GroupApi.instance) {
      GroupApi.instance = new GroupApi();
      GroupApi._initPromise = GroupApi.instance.init();
    }
    await GroupApi._initPromise;
    return GroupApi.instance;
  }

  async fetchGroups(attempt = 0) {
    try {
      const res = await this.get(`user/${this.userId}/groups`);

      if (this.isSuccess(res.status)) {
        return res.data.groups;
      } else {
        store.dispatch(showError(true, `Server error when try to get groups. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchGroups.bind(this), error, attempt);
    }
  }

  async renameGroup(title, group, attempt = 0) {
    try {
      const res = await this.patch(`user/${this.userId}/group/${group.id}`, {
        title,
        readonly: group.is_readonly,
        default: group.default,
      });

      if (!this.isSuccess(res.status)) {
        store.dispatch(showError(true, `Server error when try to rename group. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.renameGroup.bind(this), error, attempt, title, group);
    }
  }

  async addGroup(title, attempt = 0) {
    try {
      const res = await this.post(`user/${this.userId}/groups`, {
        title,
        readonly: false,
        default: false
      });

      if (this.isSuccess(res.status)) {
        return res.data;
      } else {
        store.dispatch(showError(true, `Server error when try to add group. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.addGroup.bind(this), error, attempt, title);
    }
  }

  async deleteGroup(id, attempt = 0) {
    try {
      const res = await this.delete(`user/${this.userId}/group/${id}`);

      if (this.isSuccess(res.status)) {
        return true;
      } else {
        store.dispatch(showError(true, `Server error when try to delete group. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.deleteGroup.bind(this), error, attempt, id);
    }
  }
}
